export default __webpack_public_path__ + "files/877d78882f3d31cbbd77cf4c998d4864.svg";